<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          <img
            :src="`/img/repair/${categoryInfo.slug}/${serviceInfo.slug}.jpg`"
            :alt="subcategoryInfo.name"
            :title="subcategoryInfo.name"
            :data-fallback="`https://placehold.co/600?text=${subcategoryInfo.name}`"
            onerror="this.onerror=null;this.src=this.getAttribute('data-fallback')"
          />
        </div>
        <div class="col-md-6">
          <RepairServiceForm
            :categoryInfo="categoryInfo"
            :subcategoryInfo="subcategoryInfo"
            :selectedService="serviceInfo"
          />
        </div>
      </div>
      <div class="row mt-20">
        <div class="container">
          <div class="col-md-12">
            <div v-html="serviceInfo[`content_${$i18n.locale}`]"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RepairPageMixin from '@/components/repair/RepairPageMixin'
import RepairServiceForm from '@/components/repair/RepairServiceForm'

export default {
  name: 'RepairServiceSubcategoryService',
  mixins: [RepairPageMixin],
  components: { RepairServiceForm },
  metaInfo() {
    return {
      title: this.$t('meta.other.titleTmpl', {
        h1: `${this.serviceInfo[`description_${this.$i18n.locale}`]} ${
          this.serviceInfo.price
            ? this.getPrice(this.serviceInfo)
            : this.emptyPrice
        }`,
      }),
    }
  },
}
</script>

<style>
</style>
